import StaticPage, { Section } from "../components/StaticPage";

export default function Terms() {
    return (
        <StaticPage
            title="Terms of Service · ZenZest"
            description="Terms of service for weeddispensarynearme.com and the connected Dutchie checkout, operated for ZenZest, a NY-licensed adult-use cannabis retailer."
            canonical="https://weeddispensarynearme.com/terms"
            eyebrow="Legal · last updated Feb 2026"
            h1="Terms of service."
            intro="Plain-English rules for using the site, placing orders, and participating in ZenCircle. By using the site, you agree to them."
            toc={[
                { id: "eligibility", label: "Eligibility" },
                { id: "site-use", label: "Site use" },
                { id: "orders", label: "Orders" },
                { id: "loyalty", label: "ZenCircle" },
                { id: "ip", label: "Intellectual property" },
                { id: "disclaimers", label: "Disclaimers" },
                { id: "liability", label: "Limitation of liability" },
                { id: "law", label: "Governing law" },
            ]}
        >
            <Section id="eligibility" title="Eligibility (21+ only)">
                <p>
                    You must be 21+ with a valid government-issued ID to use this
                    site, place an order, or join ZenCircle. By using the site
                    you affirm you meet that age requirement.
                </p>
            </Section>

            <Section id="site-use" title="Site use">
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>
                        Don&rsquo;t use the site in violation of any law (federal,
                        state, or local).
                    </li>
                    <li>
                        Don&rsquo;t attempt to break, scrape, or reverse-engineer
                        the site or its APIs.
                    </li>
                    <li>
                        Don&rsquo;t impersonate anyone, submit false age-verification
                        documents, or use someone else&rsquo;s account.
                    </li>
                </ul>
            </Section>

            <Section id="orders" title="Orders & fulfillment">
                <p>
                    Every order is subject to in-store ID verification at pickup
                    or at the door for delivery. NY law sets a single-transaction
                    limit of 3 oz of cannabis flower or 24 g of concentrate.
                    Cannabis cannot cross state lines.
                </p>
                <p>
                    Pricing displayed on the site is what you pay (tax included
                    where shown after-tax). We reserve the right to cancel any
                    order that violates NY law, exceeds inventory, or fails
                    age verification.
                </p>
                <p>
                    Payments are cash, debit, or digital bank transfer where
                    available. Federal banking restrictions still bar
                    dispensaries from processing credit cards.
                </p>
            </Section>

            <Section id="loyalty" title="ZenCircle rewards">
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>Free to join. 21+ NY-resident customers only.</li>
                    <li>
                        Points accrue on qualifying purchases at ZenZest Queens
                        and Staten Island. Tier multipliers apply based on your
                        180-day rolling spend.
                    </li>
                    <li>
                        Points expire after 180 days of inactivity. Any single
                        purchase resets the clock on every point you have.
                    </li>
                    <li>
                        ZenCircle is operated through Alpine IQ. Marketing SMS
                        opt-in is optional and can be withdrawn anytime by
                        replying STOP.
                    </li>
                    <li>
                        We may modify the program (rates, tiers, redemption
                        ladder) with 30 days&rsquo; notice via SMS or in-app.
                    </li>
                </ul>
            </Section>

            <Section id="ip" title="Intellectual property">
                <p>
                    Site design, copy, photography, and the ZenZest mark are
                    owned by ZenZest. Product photos and brand marks belong to
                    their respective brands. Don&rsquo;t use any of it commercially
                    without written permission.
                </p>
            </Section>

            <Section id="disclaimers" title="Disclaimers">
                <p>
                    Cannabis is a federally controlled substance. Cannabis use
                    can impair the ability to operate a vehicle or heavy
                    machinery. Cannabis may carry long-term health risks
                    including risks to mental health, lung health, and
                    pregnancy. Keep cannabis out of reach of children and pets.
                    Nothing on this site is medical advice. Consult a
                    physician before using cannabis if you have a
                    medical condition or take prescription medication.
                </p>
            </Section>

            <Section id="liability" title="Limitation of liability">
                <p>
                    To the maximum extent permitted by NY law, ZenZest and its
                    operators are not liable for indirect, incidental, or
                    consequential damages arising from site use. Our total
                    liability for any direct damages is capped at the amount
                    you paid for the order in question.
                </p>
            </Section>

            <Section id="law" title="Governing law & disputes">
                <p>
                    These terms are governed by the laws of the State of New
                    York. Any disputes will be resolved in the state or federal
                    courts located in Queens County, NY.
                </p>
                <p>
                    Questions: email{" "}
                    <a
                        href="mailto:legal@zenzest.com"
                        className="text-zen-ink underline"
                    >
                        legal@zenzest.com
                    </a>
                    .
                </p>
            </Section>
        </StaticPage>
    );
}
